import { render, staticRenderFns } from "./ServicesCase.vue?vue&type=template&id=4a9bdf0d&scoped=true&"
import script from "./ServicesCase.vue?vue&type=script&lang=js&"
export * from "./ServicesCase.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCase.vue?vue&type=style&index=0&id=4a9bdf0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bdf0d",
  null
  
)

export default component.exports